<template>
   <div class="site-navbar row yo-padding-top-s">
      <div class="col s11 offset-sm navbar-header">
         <router-link to="/"><img src="/site/images/eflm-logo.png" alt="Eflm Logo" width="244" height="60"/></router-link>
      </div>

      <div class="col s12" style="margin: 32px 0">
         <el-menu mode="vertical" :router="false" class="yo-margin-left-xxs" :default-active="activeIndex">
            <el-sub-menu index="/">
               <template #title><router-link to="/">E-LEARNING EVENTS</router-link></template>
               <router-link to="/live-webinar"><el-menu-item index="/live-webinar">LIVE WEBINARS</el-menu-item></router-link>
               <router-link to="/on-demand-webinar"><el-menu-item index="/on-demand-webinar">ON-DEMAND WEBINARS</el-menu-item></router-link>
               <router-link to="/syllabus-course"><el-menu-item index="/syllabus-course">SYLLABUS COURSE</el-menu-item></router-link>
               <router-link to="/interactive-contents"><el-menu-item index="/interactive-contents">INTERACTIVE CONTENTS</el-menu-item></router-link>
            </el-sub-menu>
            

            <router-link to="/page/cpecs"><el-menu-item index="/page/cpecs">EFLM Continuing Professional Education Credit System – CPECS®</el-menu-item></router-link>
            <router-link to="/page/other-resources"><el-menu-item index="/page/other-resources">OTHER EFLM RESOURCES</el-menu-item></router-link>
            <router-link to="/page/contact"><el-menu-item index="/page/contact">CONTACT</el-menu-item></router-link>
            <!--<router-link to="/page/external-resources"><el-menu-item index="/page/external-resources">EXTERNALS RESOURCES</el-menu-item></router-link>-->
         </el-menu>
      </div>
   </div>
</template>

<script>
import { ElMenu, ElSubMenu, ElMenuItem } from "element-plus"
export default {
   components: {
      ElMenu, ElSubMenu, ElMenuItem
   },
   data(){
      return{
         
      }
   },
   computed: {
      activeIndex: function (){
         return this.$route.path
      }
   }
}
</script>